export default function blogSearchForm (document, moduleHTML, appEventEmitter) {
  const form = moduleHTML

  form.addEventListener('submit', (event) => {
    event.preventDefault()
    const value = form.querySelector('input').value
    if (value) {
      window.location = `/blog/search?q=${value}`
    }
  })
}
